import {
  apiRequest,
  gradeDetail,
  gradePositionList,
  gradeList,
  updateGrade,
} from "../../../../../services/adapters/kepegawaian/revisiTunjanganKhususService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      updateGrade,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      gradeDetail,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchGrade = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      gradeList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchPosition = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      gradePositionList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
